// extracted by mini-css-extract-plugin
module.exports = {"DoubleInputContainer":"CreateUser_DoubleInputContainer__gChDd","InputContainer":"CreateUser_InputContainer__ktn0j"};